import { useState } from "react";
import MuiStepper from "../components/stepper/MuiSteper";
import Submit from "../pages/submit/Submit";
import ClinicInfo from "./ClinicInfo";
import PatientInfo2 from "./PatientInfo2";
import DesignLinerReview from "./DesignLinerReview";
import apiClient from "../common/apiClient";
import AccountNumberPage from "./AccountNumberPage";

import MultipleDesignerLinerSelection from "./MultipleDesignerLinerSelection";
import DesignerLinerFormTypeSelection from "./DesignerLinerFormTypeSelection";

const DesignerLinerBundle = () => {
  const [activeInnerStep, setActiveInnerStep] = useState(0);
  const [activeOuterStep, setActiveOuterStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);
  const [cart, setCart] = useState(Array(0));
  const [tempCart, setTempCart] = useState(Array(0));
  const [init, setInit] = useState(true);
  const [openClear, setOpenClear] = useState(false);
  const [showClear, setShowClear] = useState(true);
  const [designLinerInnerSteps, setDesignLinerInnerSteps] = useState([]);

  const formTypeId = 23;

  const loadCart = (skipFormSteps = false) => {
    if (!skipFormSteps) {
      getFormSteps()
    }
    setTempCart([]);

    apiClient.get("cart/" + formTypeId
    ).then(response => {
      setCart(response.data);
    }).catch(error => {
      console.log(error)
    });
  }

  const joinedCart = () => {
    let uniqueMainCart = cart.filter(c => !tempCart.some(t => t.sourceId?.toLowerCase() === c.sourceId?.toLowerCase() || t.name === c.name));

    return uniqueMainCart.concat(tempCart);
  }

  const handleNext = () => {
    loadCart();
    if (activeOuterStep === formData?.length - 1) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep + 1);
      setActiveInnerStep(0);
    }
  };
  const handleBack = () => {
    loadCart();
    if (activeOuterStep === 0) {
      return;
    } else {
      setActiveOuterStep(activeOuterStep - 1);
    }
  };

  const handleClearBack = () => {
    loadCart();
    setActiveOuterStep(0);
  };

  const handleClickOpen = (name) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setShowSubmit(true);
  };

  const handleClickClearOpen = (name) => {
    setOpenClear(true);
  };

  const handleCloseClear = () => {
    setOpenClear(false);
    setShowClear(true);
  };

  const getFormSteps = (inactiveSteps = []) => {
    const formSteps = [
      { id: 2, name: "Shape Creation", isActive: true },
      { id: 12, name: "Patient Information", isActive: true },
      { id: 3, name: "Measurements", isActive: true },
      { id: 4, name: "Liner Type", isActive: true },
      { id: 5, name: "Interface Material", isActive: true },
      { id: 6, name: "Fabric", isActive: true },
      { id: 7, name: "Fabric Color", isActive: true },
      { id: 8, name: "Liner Design", isActive: true },
      { id: 9, name: "Quantity", isActive: true },
      { id: 10, name: "Request Design Technician", isActive: true },
      { id: 11, name: "Notes", isActive: true },
    ];

    const activeFormSteps = formSteps.filter(fs => {
      if (!inactiveSteps.includes(fs.id)) {
        return fs;
      }
    })

    setDesignLinerInnerSteps(activeFormSteps);
  }

  const setActiveInnerStepById = (id) => {
    const formSteps = designLinerInnerSteps;
    const innerStepIndex = formSteps.indexOf(formSteps.find(i => i.id === id));
    setActiveInnerStep(innerStepIndex);
  }

  const formData = [

    {
      id: 1,
      name: "Form Type Selection",
      innerSteps: [],
      formContent: (
        <DesignerLinerFormTypeSelection
          disableBackButton={localStorage.getItem("internalAccount") === null}
          setActiveInnerStep={setActiveInnerStepById}
          getFormSteps={getFormSteps}
          innerStep={activeInnerStep}
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          loadCart={loadCart}
          handleClearBack={handleClearBack}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
          isBilateral={false}
          setActiveOuterStep={setActiveOuterStep}
          formIndex={null}
        />
      ),
    },
    {
      id: 4,
      name: "Product Information",
      innerSteps: designLinerInnerSteps,
      formContent: (
        <MultipleDesignerLinerSelection
          setActiveInnerStep={setActiveInnerStepById}
          getFormSteps={getFormSteps}
          innerStep={activeInnerStep}
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          loadCart={loadCart}
          handleClearBack={handleClearBack}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
          isBilateral={false}
          setActiveOuterStep={setActiveOuterStep}
          formIndex={null}
        />
      ),
    },

    {
      id: 6,
      name: "Customer information",
      innerSteps: [],
      formContent: (
        <ClinicInfo
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          loadCart={loadCart}
          handleClearBack={handleClearBack}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
        />
      ),
    },

    {
      id: 7,
      name: "Shipping Information",
      innerSteps: [],
      formContent: (
        <PatientInfo2
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          loadCart={loadCart}
          handleClearBack={handleClearBack}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
        />
      ),
    },

    {
      id: 8,
      name: "Order Review",
      innerSteps: [],
      formContent: (
        <DesignLinerReview
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          formName="Design Liner"
        />
      ),
    },

    {
      id: 9,
      name: "Submit",
      innerSteps: [],
      formContent: <Submit />,
    },
  ];
  if (localStorage.getItem("internalAccount")) {
    formData.unshift({
      id: 0,
      name: "Account Number",
      formContent: (
        <AccountNumberPage
          setActiveInnerStep={setActiveInnerStep}
          formTypeId={formTypeId}
          handleNext={handleNext}
          handleBack={handleBack}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          showSubmit={showSubmit}
          setShowSubmit={setShowSubmit}
          open={open}
          setTempCart={setTempCart}
          loadCart={loadCart}
          handleClearBack={handleClearBack}
          handleClickClearOpen={handleClickClearOpen}
          handleCloseClear={handleCloseClear}
          showClear={showClear}
          setShowClear={setShowClear}
          openClear={openClear}
        />
      )
    })
  }

  const totalIds = formData.reduce((count) => {
    return count + 1;
  }, 0);

  if (init) {
    loadCart();
    setInit(false);
  }

  return (
    <>
      <div style={{ display: "flex", width: "100%" }}>
        <MuiStepper
          data={formData}
          innerStep={activeInnerStep}
          setInnerStep={setActiveInnerStep}
          setActiveOuterStep={setActiveOuterStep}
          activeOuterStep={activeOuterStep}
          formName="Design Liner"
          totalSteps={totalIds}
          cart={joinedCart()}
        />
      </div>
    </>
  );
};

export default DesignerLinerBundle;